import { IUser } from 'src/models';
import { IOauthToken } from 'src/models/oauth-token/OauthToken';
import { ILoginData } from 'src/screens';
import { IRegisterFormData } from 'src/screens/auth/register/register-form/RegisterForm';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/user';

/** 로그인 */
export const login = async (loginData: ILoginData) => {
  try {
    const url = `${SUB_URL}/login`;

    const response = await instance.post<TApiResponseData<IOauthToken>>(url, loginData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 로그아웃 */
export const logout = async () => {
  try {
    const url = `${SUB_URL}/logout`;

    const response = await instance.get<TApiResponseData<IUser>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 내 정보 조회 */
export const getUserProfile = async () => {
  try {
    const url = `${SUB_URL}/profile`;

    const response = await instance.get<TApiResponseData<IUser>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 아이디 찾기 */
export const findLoginId = async (verifyKey: string) => {
  try {
    const url = `${SUB_URL}/find/loginId`;
    const payload = {
      verifyKey,
    };

    const response = await instance.post<TApiResponseData<any>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 비밀번호 재설정 (로그인 이전) */
export const resetPwd = async (user: IUser) => {
  try {
    const url = `${SUB_URL}/reset/pwd`;

    const response = await instance.put<TApiResponseData<any>>(url, user);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 비밀번호 변경(로그인 이후) */
export const changePwd = async (user: IUser) => {
  try {
    const url = `${SUB_URL}/change/pwd`;

    const response = await instance.put<TApiResponseData<any>>(url, user);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 아이디 중복 확인 */
export const checkDuplicateLoginId = async (loginId: string) => {
  try {
    const url = `${SUB_URL}/check/duplicate/loginId?loginId=${loginId}`;

    const response = await instance.get<TApiResponseData<any>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 회원가입 */
export const register = async (formData: IRegisterFormData) => {
  try {
    const url = `${SUB_URL}/signup`;

    const response = await instance.post<TApiResponseData<IOauthToken>>(url, formData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 토큰 재발급 */
export const loginRefresh = async (refreshToken: string) => {
  try {
    const url = `${SUB_URL}/login/refresh`;
    const payload = {
      refreshToken,
    };

    const response = await instance.post<TApiResponseData<IOauthToken>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 언어 변경 */
export const changeLanguage = async (langCd: string) => {
  try {
    const url = `${SUB_URL}/lang`;
    const payload = {
      refreshToken: localStorage.getItem('refreshToken'),
      langCd: langCd,
    };

    const response = await instance.put<TApiResponseData<IOauthToken>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 회원탈퇴 */
export const withdrawal = async () => {
  try {
    const url = `${SUB_URL}/withdrawal`;

    const response = await instance.delete<TApiResponseData<any>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
